import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import {
  INVESTOR_DETAIL_URL,
  SERVICE_PROVIDER_DETAIL_URL,
  COMPANY_DETAIL_URL
} from 'global-constants';
import { substituteUrl } from 'shared/utils/substituteUrl';

import { getImageStyle } from 'shared/utils/getImageStyle';
import defaultLogo from 'assets/images/default_logo.svg';
import featuredRibbon from 'assets/images/featured-ribbon.svg';

import { truncateText } from 'shared/utils/truncateText';
import styles from './styles.module.scss';

class FeaturedCompanyBox extends React.Component {
  getRedirectLink = () => {
    const { isServiceProvider, isInvestor, slug } = this.props;

    if (isServiceProvider) {
      return substituteUrl(SERVICE_PROVIDER_DETAIL_URL, {
        serviceProviderSlug: slug
      });
    }

    if (isInvestor) {
      return substituteUrl(INVESTOR_DETAIL_URL, {
        investorSlug: slug
      });
    }

    return substituteUrl(COMPANY_DETAIL_URL, { companySlug: slug });
  };

  render() {
    const {
      title,
      label,
      headline,
      handleClick,
      className,
      description,
      featured = true,
      imageData: {
        image = null,
        thumbnails = [],
        width = 50,
        height = 50,
        defaultImage = defaultLogo
      },
      isInvestor = false
    } = this.props;

    const headlineText = headline && headline !== '' ? headline : description;

    return (
      <div>
        {featured && (
          <div className={styles.featuredRibbon}>
            <img src={featuredRibbon} alt="Featured Company" />
          </div>
        )}
        <div
          className={classnames(
            styles.imageBoxWrapper,
            { [styles.investorBox]: isInvestor },
            className
          )}
          onClick={handleClick}>
          <Link
            to={this.getRedirectLink()}
            className={styles.imageContainer}
            style={getImageStyle({
              image,
              thumbnails,
              width,
              height,
              defaultImage
            })}
          />
          <Link to={this.getRedirectLink()} className={styles.title}>
            <h4>{truncateText(title, 25)}</h4>
          </Link>
          <div
            className={styles.label}
            dangerouslySetInnerHTML={{ __html: label }}
          />
          <div className={styles.divider} />
          <div className={styles.headlineAndBtnWrapper}>
            {!isInvestor && (
              <div className={styles.headline}>
                {truncateText(headlineText, 120)}
              </div>
            )}
            <Link className={styles.companyLink} to={this.getRedirectLink()}>
              Find out more
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default FeaturedCompanyBox;
